import { VoiceMessageBuilder } from '../../../settings';
import { CallActionType } from '../../ivr';
var QueueNonAvailableAgentsSettingsBuilder = /** @class */ (function () {
    function QueueNonAvailableAgentsSettingsBuilder() {
        this.queueNonAvailableAgentsSettings = {
            nonAvailableAgentsMessage: new VoiceMessageBuilder().build(),
            nonAvailableAgentsAction: {
                type: CallActionType.HANGUP
            }
        };
    }
    QueueNonAvailableAgentsSettingsBuilder.prototype.withNonAvailableAgentsMessage = function (nonAvailableAgentsMessage) {
        this.queueNonAvailableAgentsSettings.nonAvailableAgentsMessage = nonAvailableAgentsMessage;
        return this;
    };
    QueueNonAvailableAgentsSettingsBuilder.prototype.withNonAvailableAgentsAction = function (nonAvailableAgentsAction) {
        this.queueNonAvailableAgentsSettings.nonAvailableAgentsAction = nonAvailableAgentsAction;
        return this;
    };
    QueueNonAvailableAgentsSettingsBuilder.prototype.build = function () {
        return this.queueNonAvailableAgentsSettings;
    };
    return QueueNonAvailableAgentsSettingsBuilder;
}());
export { QueueNonAvailableAgentsSettingsBuilder };
//# sourceMappingURL=queue-non-available-agent-settings.builder.js.map